import apiClient from "../utils/axiosConfig";
import { API_ENDPOINTS, getApiUrl } from "../Configurations/config";

class SemanticService {
  async checkAccess(email) {
    const response = await apiClient.post(getApiUrl(API_ENDPOINTS.SEMANTIC.CHECK_ACCESS), { email });
    return response.data;
  }
}

export const semanticService = new SemanticService();
export default semanticService;
